<template>
  <div class="flex rating border border-2 p-2 rounded-xl leading-4"
       :class="[colorClass, fillClass, className]"
       >
    {{ score || '-' }}
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, watch, ref } from 'vue';
import { useAgilityRating } from '@/hooks/useAgilityRating';

export default defineComponent({
  name: 'AgilityRatingPill',
  props: {
    className: {
      type: String,
      default: ''
    },
    score: {
      type: Number,
      required: true
    },
    type: {
      type: String,
      default: 'border'
    },
    fill: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const currentScore = ref(props.score);
    
    // Watch for changes to the score prop
    watch(() => props.score, (newScore) => {
      if (newScore !== undefined) {
        currentScore.value = newScore;
      }
    });

    const className = computed(() => {
      return props.className;
    });
    
    const colorClass = computed(() => {
      if (currentScore.value === undefined) {
        return '';
      }
      
      const { getClass } = useAgilityRating(currentScore.value);
      return getClass(props.fill ? 'bg' : props.type as any);
    });
    
    // Add text-black class when fill is true
    const fillClass = computed(() => {
      return props.fill ? 'text-black border-0 font-medium' : '';
    });
    
    return {
      colorClass,
      className,
      fillClass,
      score: computed(() => props.score)
    };
  }
});
</script> 